import {
  Box,
  Flex,
  Container,
  Image,
  Link as ChakraLink,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuGroup,
  MenuDivider,
  Button,
  Text,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../assets/logo.png";
import { useCategories } from "../hooks/useCategories";

const Navbar = () => {
  const { categories } = useCategories();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const MAX_DIRECT = 6;
  const directCategories = categories.slice(0, MAX_DIRECT);
  const overflowCategories = categories.slice(MAX_DIRECT);

  return (
    <Box
      as="nav"
      position="sticky"
      top={0}
      zIndex={1000}
      bg="rs.bg"
      borderBottom="1px solid"
      borderColor={scrolled ? "rs.borderStrong" : "rs.border"}
      transition="border-color 0.3s ease, box-shadow 0.3s ease"
      boxShadow={scrolled ? "0 4px 24px rgba(0,0,0,0.4)" : "none"}
    >
      <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
        <Flex h="62px" align="center" justify="space-between">
          <RouterLink to="/">
            <Flex align="center" gap={3}>
              <Image
                src={logo}
                alt="Red Shutter"
                height="36px"
                objectFit="contain"
              />
              <Text
                fontFamily="'DM Serif Display', serif"
                fontSize="16px"
                color="rs.text"
                display={{ base: "none", md: "block" }}
                letterSpacing="0.01em"
              >
                <Box as="span" color="rs.red">
                  RED
                </Box>{" "}
                Shutter
              </Text>
            </Flex>
          </RouterLink>

          <Flex gap={7} align="center">
            {directCategories.map((category) => {
              if (category.subcategories.length === 0) {
                return (
                  <ChakraLink
                    key={category.id}
                    as={RouterLink}
                    to={`/category/${category.slug}`}
                    fontSize="12.5px"
                    fontWeight="400"
                    color="rs.textMuted"
                    letterSpacing="0.01em"
                    _hover={{ color: "rs.text" }}
                    transition="color 0.15s"
                  >
                    {category.name}
                  </ChakraLink>
                );
              }

              return (
                <Menu key={category.id}>
                  <MenuButton
                    as={ChakraLink}
                    fontSize="12.5px"
                    fontWeight="400"
                    color="rs.textMuted"
                    letterSpacing="0.01em"
                    _hover={{ color: "rs.text" }}
                  >
                    <RouterLink to={`/category/${category.slug}`}>
                      {category.name}
                    </RouterLink>
                  </MenuButton>
                  <MenuList minW="200px">
                    {category.subcategories.map((sub) => (
                      <MenuItem
                        key={sub.slug}
                        as={RouterLink}
                        to={`/category/${category.slug}/${sub.slug}`}
                      >
                        {sub.name}
                      </MenuItem>
                    ))}
                  </MenuList>
                </Menu>
              );
            })}

            {overflowCategories.length > 0 && (
              <Menu>
                <MenuButton
                  as={Button}
                  variant="ghost"
                  fontSize="12.5px"
                  fontWeight="400"
                  color="rs.textMuted"
                  _hover={{ color: "rs.text", bg: "transparent" }}
                  _active={{ bg: "transparent" }}
                  rightIcon={<ChevronDownIcon />}
                  px={0}
                  h="auto"
                  minH={0}
                  py={0}
                  border="none"
                >
                  More
                </MenuButton>
                <MenuList minW="200px">
                  {overflowCategories.map((category) =>
                    category.subcategories.length === 0 ? (
                      <MenuItem
                        key={category.id}
                        as={RouterLink}
                        to={`/category/${category.slug}`}
                      >
                        {category.name}
                      </MenuItem>
                    ) : (
                      <Box key={category.id}>
                        <MenuGroup title={category.name}>
                          <MenuItem
                            as={RouterLink}
                            to={`/category/${category.slug}`}
                          >
                            All {category.name}
                          </MenuItem>
                          {category.subcategories.map((sub) => (
                            <MenuItem
                              key={sub.slug}
                              as={RouterLink}
                              to={`/category/${category.slug}/${sub.slug}`}
                              pl={6}
                            >
                              {sub.name}
                            </MenuItem>
                          ))}
                        </MenuGroup>
                        <MenuDivider />
                      </Box>
                    ),
                  )}
                </MenuList>
              </Menu>
            )}

            <ChakraLink
              as={RouterLink}
              to="/#contact"
              fontSize="12.5px"
              fontWeight="400"
              color="rs.textMuted"
              letterSpacing="0.01em"
              _hover={{ color: "rs.text" }}
              transition="color 0.15s"
            >
              Contact
            </ChakraLink>
          </Flex>

          <Flex gap={2} display={{ base: "none", lg: "flex" }}>
            <Button
              as={RouterLink}
              to="/#contact"
              variant="outline"
              size="sm"
              fontSize="12px"
              px={4}
            >
              Contact us
            </Button>
            <Button
              as={RouterLink}
              to="/#rent"
              variant="solid"
              size="sm"
              fontSize="12px"
              px={4}
            >
              Rent now
            </Button>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Navbar;
